import { BaseValidator } from '../core/BaseValidator.js';
import { ValidationResult } from '../core/ValidationResult.js';

/**
 * Norwegian Personalnummer validator following Single Responsibility Principle
 */
export class PersonalnummerValidator extends BaseValidator {
  constructor() {
    super({
      name: 'Norwegian Personalnummer',
      pattern: /^\d{11}$/,
      length: 11
    });
  }

  validateFormat(id) {
    // Check length
    const lengthValidation = this.validateLength(id, this.config.length);
    if (!lengthValidation.isValid) {
      return lengthValidation;
    }

    // Check pattern
    return this.validateRegex(
      id,
      this.config.pattern,
      'Personalnummer must be exactly 11 digits'
    );
  }

  validateChecksum(id) {
    // First check digit (position 9)
    const weights1 = [3, 7, 6, 1, 8, 9, 4, 5, 2];
    let sum1 = 0;
    for (let i = 0; i < 9; i++) {
      sum1 += parseInt(id[i]) * weights1[i];
    }
    const checkDigit1 = 11 - (sum1 % 11);
    const expectedFirst = checkDigit1 === 11 ? 0 : checkDigit1;

    if (expectedFirst !== parseInt(id[9])) {
      return ValidationResult.invalid('Invalid first check digit');
    }

    // Second check digit (position 10)
    const weights2 = [5, 4, 3, 2, 7, 6, 5, 4, 3, 2];
    let sum2 = 0;
    for (let i = 0; i < 10; i++) {
      sum2 += parseInt(id[i]) * weights2[i];
    }
    const checkDigit2 = 11 - (sum2 % 11);
    const expectedSecond = checkDigit2 === 11 ? 0 : checkDigit2;

    if (expectedSecond !== parseInt(id[10])) {
      return ValidationResult.invalid('Invalid second check digit');
    }

    return ValidationResult.valid('Valid Personalnummer');
  }
}